export const DEFAULT_STATE = {
    data: [],
    isLoading: false,
    fees: null,
    fee: null,
    websiteSelected: "all",
};
